import React from 'react';

import api from '../../api';
import useHttpData from '../../hooks/useHttpData';
import AsyncSection from './AsyncSection';
import { formatPct } from './gatewayHealth';

const prettyBrand = brand => (brand ? brand.charAt(0).toUpperCase() + brand.slice(1) : '—');

// Retailer gateway health broken down by inverter brand — computed from the raw
// reports scoped to this retailer's gateways.
const GatewayByBrand = ({ from, to }) => {
    const { data, isReady, error } = useHttpData(() => api.get_gateway_health_by_brand(from, to), [from, to]);
    const brands = data?.data?.brands ?? [];

    return (
        <div className="gateways-overview__alarms gw-brand">
            <h2 className="gateways-overview__alarms-title">By inverter brand</h2>
            <p className="gateways-overview__alarms-hint">Health metrics for each inverter brand in your fleet.</p>
            <AsyncSection
                isReady={isReady}
                error={error}
                isEmpty={brands.length === 0}
                errorText="Could not load per-brand health."
                emptyText="No brand data for this period."
            >
                <table className="gw-brand__table">
                    <thead>
                        <tr>
                            <th>Inverter brand</th>
                            <th>Gateways</th>
                            <th>Healthy</th>
                            <th>Setpoint following</th>
                            <th>Schedule following</th>
                            <th>Data coverage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {brands.map(brand => (
                            <tr key={brand.inverter_brand}>
                                <td>{prettyBrand(brand.inverter_brand)}</td>
                                <td>{brand.total_gateways}</td>
                                <td>{formatPct(brand.percentage_healthy)}</td>
                                <td>{formatPct(brand.setpoint_following_score_avg)}</td>
                                <td>{formatPct(brand.schedule_following_score_avg)}</td>
                                <td>{formatPct(brand.data_coverage_avg)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </AsyncSection>
        </div>
    );
};

export default GatewayByBrand;
